// i18n area 'common' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.fi-FI.meta.json.
import type { enUS } from './common'

export const fiFI: typeof enUS = {
  nav: {
    home: 'Etusivu',
    vms: 'Virtuaalikoneet',
    templates: 'Templatet',
    importVms: 'Tuo VM:iä',
    containers: 'Containerit',
    containersApps: 'Sovellukset',
    containersPods: 'Podit',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-imaget',
    containersOciRegistries: 'OCI-registryt',
    containersCtTemplates: 'CT-templatet',
    networkServices: 'Verkkopalvelut',
    firewall: 'Palomuuri',
    checkpoints: 'Checkpointit',
    backup: 'Backup',
    monitoring: 'Valvonta',
    cluster: 'Klusteri',
    clusterSettings: 'Yleiset asetukset',
    clusterNodes: 'Solmut',
    clusterDevices: 'USB- ja PCIe-resurssit',
    clusterFederation: 'Federaatio',
    network: 'Verkko',
    overlayNetworks: 'Overlay-verkot',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Data',
    storages: 'Storaget',
    hci: 'Hyperkonvergenssi',
    ceph: 'Ceph',
    system: 'Järjestelmä',
    tasks: 'Taskit',
    events: 'Tapahtumat',
    audit: 'Auditointi',
    diagnostics: 'Diagnostiikka',
    notifications: 'Ilmoitukset',
    proximity: 'TVirt Proximity',
    users: 'Käyttäjät ja ryhmät',
    groups: 'Ryhmät',
    mfa: 'MFA',
    realms: 'Realmit ja SSO',
    rbac: 'Roolit ja oikeudet',
    credentials: 'Tunnistetiedot',
    scopes: 'Scopet',
    tags: 'Tagit',
    explorer: 'Selaa',
    licensing: 'Lisenssi',
    information: 'Tietoja'
  },
  mode: {
    light: 'Vaalea',
    dark: 'Tumma',
    system: 'Järjestelmä',
    tooltip: 'Teema'
  },
  language: {
    tooltip: 'Kieli'
  },
  langRegion: {
    europe: 'Eurooppa',
    northAmerica: 'Pohjois-Amerikka',
    southAmerica: 'Etelä-Amerikka',
    asia: 'Aasia'
  },
  notFound: {
    title: 'Sivua ei löytynyt',
    body: 'Tämä osoite ei vastaa mitään TVirtin sivua — se on voinut siirtyä päivityksen myötä, tai linkki on vanha.',
    backHome: 'Palaa etusivulle'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Koko klusteri',
    noChildren: 'Ei ali-scopeja täällä',
    recursive: 'Sisällytä jälkeläiset',
    collapse: 'Pienennä scope-paneeli',
    openPicker: 'Selaa scopeja',
    up: 'Nouse tasoa ylemmäs',
    countTooltip: '{direct} tässä scopessa · {total} jälkeläisten kanssa'
  },
  search: {
    tooltip: 'Hae (⌘K)',
    placeholder: 'Hae VM:iä, verkkoja, storagea…',
    empty: 'Ei tuloksia',
    groups: {
      recent: 'Viimeisimmät',
      shortcuts: 'Pikavalinnat',
      actions: 'Toiminnot',
      goTo: 'Siirry'
    },
    kind: {
      catalog: 'Katalogi',
      scope: 'Scope',
      node: 'Solmu'
    },
    footer: {
      navigate: 'liiku',
      open: 'avaa',
      close: 'sulje'
    },
    actions: {
      createVm: 'Luo VM…',
      uploadIso: 'Lataa ISO…',
      clusterSettings: 'Klusterin asetukset',
      consoleOf: 'Siirry koneen {name} konsoliin'
    }
  },
  stub: {
    containersSummary: 'Sovellukset ja järjestelmäcontainerit (CT) OCI-imageineen, registryineen ja templateineen — hallittuina VM:iesi rinnalla.',
    sectionSummary_vms: 'Virtuaalikoneet ja niiden templatet — elinkaari, snapshotit, migrointi ja konsoli.',
    sectionSummary_storages: 'Storaget, joilla VM:ien levyt, levykuvat ja metadata elävät.',
    sectionSummary_catalogs: 'Klusterin tiedostoartefaktien koti: ISO-levykuvat, CT- ja VM-templatet sekä OCI-arkistot, katalogeihin järjestettyinä.',
    sectionSummary_overlay: 'VXLAN-overlay-verkot klusterisolmujen välillä.',
    sectionSummary_fabric: 'Fyysisen verkon inventaario — switchit, portit, LAGGit ja loogiset verkot.',
    sectionSummary_ipam: 'Fabric- ja overlay-verkoista johdettu osoitteistus: kuka pitää kutakin osoitetta.',
    sectionSummary_services: 'Verkkorekisteristä johdetut DHCP- ja DNS-palvelimet.',
    sectionSummary_ceph: 'TVirt-solmuilla hallitut Ceph-klusterit.',
    sectionSummary_hci: 'Hyperkonvergentit storage-teknologiat TVirt-solmuilla.',
    sectionSummary_cluster: 'Solmut, jäsenyys ja klusterin asetukset.',
    containers: 'Järjestelmäcontainerit ovat roadmapilla — tämä osio tulee majoittamaan ne.',
    containersApps: 'Containeroidut sovellukset ovat roadmapilla — tämä alue tulee majoittamaan ne.',
    containersPods: 'Podit ryhmittävät kontteja, jotka jakavat verkon ja taltiot — instanssit ovat sovelluksia.',
    containersCt: 'Järjestelmäcontainerit (CT) ovat roadmapilla — tämä alue tulee majoittamaan ne.',
    multiscsi: 'TVStor MultiSCSI on roadmapilla — tämä alue tulee majoittamaan sen.',
    clusterFederation: 'TVirt-klusterien välinen federaatio on roadmapilla — tämä alue tulee majoittamaan sen.',
    containersOciImages: 'OCI-imaget ovat roadmapilla — tämä alue tulee majoittamaan ne.',
    containersOciRegistries: 'OCI-registryt ovat roadmapilla — tämä alue tulee majoittamaan ne.',
    containersCtTemplates: 'CT-templatet ovat roadmapilla — tämä alue tulee majoittamaan ne.',
    importVms: 'ESXi- ja Proxmox-importerit saapuvat tänne: guestien konversio ja massamigrointi TVirtin sisään.',
    backup: 'Integroitu backup tulee versiossa 6.2: deduplikoidut content-addressed-repositoryt, CBT-inkrementaalit, muuttumattomuusikkunat ja repo-to-repo-replikointi.',
    monitoring: 'Klusterinlaajuiset kuormituskilpailun dashboardit (cpu.ready, PSI-paine, integroidut hälytykset) ovat tulossa — nykyään samat metriikat elävät jokaisen VM:n tiedoissa.'
  },
  home: {
    welcome: 'Kirjauduit tunnuksella: {name}',
    subtitle: 'Tässä TVirt-klusterisi yhdellä silmäyksellä.',
    loadError: 'Yleiskuvaa ei voitu ladata — onko TVirt-backend tavoitettavissa?',
    health: {
      ok: 'Kaikki kunnossa',
      warning: 'Huomio',
      critical: 'Kriittisiä ongelmia'
    },
    reason: {
      'node-down': '{subject} on sammutettu',
      'node-stale': '{subject} ei ole kuulunut vähään aikaan',
      'node-maintenance': '{subject} huoltotilassa',
      'tasks-failed': {
        one: '{n} epäonnistunut task viimeisen 24 h aikana',
        other: '{n} epäonnistunutta taskia viimeisen 24 h aikana'
      },
      'storage-degraded': 'storage {subject} degradoitunut',
      'storage-error': 'storage {subject} virhetilassa',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klusterin store ei ole tavoitettavissa',
      'license-absent': 'ei lisenssiä — uudet VM:t eivät voi käynnistyä',
      'license-expired': 'lisenssi vanhentunut — uudet VM:t eivät voi käynnistyä',
      'license-exceeded': 'lisenssiraja ylitetty — uudet VM:t eivät voi käynnistyä',
      'failover-reserve-eroded': 'failover-reservi lähes kulutettu',
      'failover-reserve-exhausted': 'failover-reservi lopussa — uudet VM:t eivät voi käynnistyä',

      'oci-cache-nearly-full': 'OCI-välimuisti lähes täynnä kohteessa {subject} — digestit poistetaan käsin',
      'oci-cache-full': 'OCI-välimuisti täynnä kohteessa {subject} — yksikään pull ei onnistu ennen kuin digestejä poistetaan',
      'config-replica-empty': 'konfiguraation replika kohteessa {subject} on TYHJÄ — solmulla ei ole klusterin konfiguraatiota ennen kuin replikointi onnistuu',
      'config-replica-stalled': 'konfiguraation replikointi kohteessa {subject} on jumissa — paikallinen kopio laahaa klusterin konfiguraation perässä'
    },
    staleChip: 'Data ei ajan tasalla',
    staleAsOf: 'viimeisin replika {time}',
    zone: {
      nodes: 'Solmut',
      failoverReserve: 'Failover-reservi',
      capacity: 'Kapasiteetti',
      workload: 'Työkuorma',
      protection: 'Suojaus',
      activity: 'Viimeaikainen toiminta'
    },
    reserve: {
      state: {
        ok: 'Reservi ehjä',
        eroded: 'Reservi lähes kulutettu',
        exhausted: 'Reservi lopussa',
        unknown: 'Reservi tuntematon'
      },
      tolerate: {
        one: 'sietää {n} solmun menetyksen',
        other: 'sietää {n} solmun menetyksen'
      },
      usedOf: '{used} / {allowed} GiB käytössä',
      keepFree: '{n} GiB pidetään vapaana failoveria varten',
      expendable: 'josta {n} uhrattavissa käytössä',
      headroom: 'vielä {n} GiB käynnistettävissä',
      short: 'reservistä puuttuu {n} GiB — uudet VM:t eivät voi käynnistyä',
      hp: {
        usedOf: '{size}:n sivut — käytössä: {used} / {allowed}',
        keepFree: 'failoveria varten vapaana pidetyt: {keep}',
        headroom: 'vielä käynnistettävissä: {n}',
        short: 'reservistä puuttuu: {n} — uudet jättisivuja käyttävät VM:t eivät voi käynnistyä'
      },
      worstCase: 'pahin tapaus: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Yksikään solmu ei ole vielä julistanut muistiaan — reserviä ei voi laskea eikä yhtään käynnistystä hylätä.',
      reason: {
        attestedDown: 'attestoitu sammuneeksi',
        maintenance: 'huoltotilassa',
        unreachable: 'ei tavoitettavissa',
        capacityUnknown: 'muistia ei julistettu'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} corea / {threads} threadia',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktiivinen VM',
        other: '{n} aktiivista VM:ää'
      },
      activeVmsUnknown: 'Aktiiviset VM:t tuntemattomia',
      lastSeen: 'nähty {time}',
      neverSeen: 'ei koskaan nähty',
      down: 'Sammutettu',
      maintenance: 'Huolto',
      stale: 'Ei tavoitettavissa'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisioitu',
      reserve: 'reservi {n} GiB',
      unobserved: 'kapasiteettia ei ole vielä havaittu',
      empty: 'Ei vielä storagea'
    },
    workload: {
      vms: 'Virtuaalikoneet',
      apps: 'Sovellukset',
      services: 'Verkkopalvelut',
      empty: 'Ei vielä yhtään',
      phasesUnknown: 'jakauma vaiheittain ei saatavilla'
    },
    protection: {
      none: 'Ei konfiguroitua varmuuskopiokohdetta — suojaa konfiguraatiosi.',
      configure: 'Konfiguroi checkpointit',
      noRuns: 'Yhtään checkpointia ei ole vielä luotu.',
      last: 'Viimeisin checkpoint',
      onTarget: 'targetilla {target}',
      viewAll: 'Checkpointit'
    },
    activity: {
      empty: 'Ei viimeaikaista toimintaa',
      failed24: {
        one: '{n} epäonnistunut 24 h:ssa',
        other: '{n} epäonnistunutta 24 h:ssa'
      },
      viewAll: 'Näytä kaikki taskit'
    }
  },
  notes: {
    title: 'Muistiinpanot',
    tabEdit: 'Muokkaa',
    tabPreview: 'Esikatselu',
    placeholder: 'Operaattorin vapaat muistiinpanot — Markdown renderöidään esikatselussa',
    empty: 'Ei muistiinpanoja',
    tooLarge: 'Muistiinpanot ylittävät 64 KiB:n rajan',
    saveError: 'Muistiinpanojen tallennus epäonnistui'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Taustajärjestelmän vastaus sisältää arvon, jota tämä käyttöliittymä ei tunne: {field}={value} — päivitä käyttöliittymä taustajärjestelmän versioon.',
    contractErrorItems: '{count} tämän luettelon kohdetta ei tämä käyttöliittymä osaa lukea ({field}={value}), eikä niitä näytetä.',
    staleHint: 'Store ei ole tavoitettavissa — tämä on tämän solmun konfiguraatioreplika; laivaston tila on tuntematon.',
    staleStateAge: 'tila hetkellä {time}',
    staleStateNever: 'tilaa ei ole koskaan saatu storesta: näet vain tämän solmun omat havainnot',
    staleStateTooltip: 'Klusterin store ei ole tavoitettavissa: havaittu tila (vaihe, solmu, agentti) tulee tämän solmun tilareplikasta ja on peräisin viimeisestä onnistuneesta lukemisesta storesta — se voi olla vanhentunut.',
    noPermission: 'Sinulla ei ole oikeutta tähän toimintoon',
    actionStillRunning: 'Toiminto on yhä kesken — lopputulos ei ole vielä tiedossa',
    staleWrite: 'Joku muu muutti tätä objektia, kun muokkasit sitä — mitään ei kirjoitettu. Lataa uudelleen ja toista muutos tuoreeseen tilaan.',
    staleReload: 'Lataa uudelleen',
    preview: 'Esikatselu',
    previewTitle: 'Tuloksen esikatselu',
    previewNothingWritten: 'Simuloitu palvelimella — mitään ei kirjoitettu.',
    previewChanged: 'Korostettuna arvot, jotka muuttuisivat.'
  },
  context: {
    copySelection: 'Kopioi valittu teksti'
  },
  crud: {
    create: 'Luo',
    viewDetails: 'Näytä tiedot',
    viewOrEdit: 'Näytä tai muokkaa',
    selected: 'valittu',
    viewUsingVms: 'Näytä resurssia käyttävät VM:t',
    clearSelection: 'Poista valinta',
    deleteSelected: 'Poista valitut',
    bulkConfirmBody: {
      one: 'Poistetaanko {count} valittu kohde? Suojattu ilmoitetaan ja säilytetään.',
      other: 'Poistetaanko {count} valittua kohdetta? Suojatut ilmoitetaan ja säilytetään.'
    },
    bulkDeleted: 'poistettu',
    bulkRefused: 'hylätty',
    fieldId: 'ID',
    createdAt: 'Luotu',
    updatedAt: 'Päivitetty',
    immutableField: 'Kiinnitetty luonnissa — contract ei salli sen muuttamista',
    immutableScope: 'Scope määrätään luonnissa; osa resursseista siirtyy omalla toiminnollaan',
    observedField: 'Havaittu tila — alustan raportoima, ei muokattavissa'
  }
}
